import * as React from 'react';
import appConfig from 'local_config';
import ColorsVariantsSelector from 'bom/components/colorsVariantsSelector/colorsVariantsSelector';
import TotalListPrice from 'bom/components/TotalListPrice';
import { calculatePrices, parseDataForBomSave } from 'bom/bomHelpers';
import { SEND_BOM_DATA_TO_AURORA, SET_NEW_PART_QUANTITY, SAVE_BOM_FOR_AURORA, SAVE_BOM_FOR_OS } from 'actions';
import DataTable from 'react-md/lib/DataTables/DataTable';
import TableBody from 'react-md/lib/DataTables/TableBody';
import TableColumn from 'react-md/lib/DataTables/TableColumn';
import TableHeader from 'react-md/lib/DataTables/TableHeader';
import TableRow from 'react-md/lib/DataTables/TableRow';
import TextField from 'react-md/lib/TextFields/TextField';
import { saveBomAndDownloadPdf } from '../../utils/saveBom';
import { isRmGridflex10D, products } from '__common/constants/products';
import { sortBomTableByUniracRequest } from './utils/bomTableSorting';
import { dispatch, state } from '__common/store';
import { isDomesticPart, PARTS_BELONG_FOR_PACK_NOTE, partToPackMap, S5_ATTACHMENT_PARTS, SM_168_PARTS, SM_208_PARTS } from '__common/constants/parts';
import { applyDomesticContent } from '__common/utils/versionCompare/versionCompare';

type Props = {
  onChangeQuantity?: Function;
  preview?: boolean;
  productId?: string;
  partsList: bomPartsList;
  dispatch: Function,
  projectId: string,
};

export default class BomTable extends React.Component<Props, {}> {
  imageX: number;
  imageY: number;
  partImageName: string;
  showImage = false;

  sendBomToTheAurora = () => {
    const{projectConfiguration:{projectId, productId}, bom: { partsList, extraParameters },railsSelector: { railsList, selectOnlySMHDRails }} = state();
    const bomSaveRequestBody = parseDataForBomSave(partsList, railsList, extraParameters, products[productId], selectOnlySMHDRails);
    if (bomSaveRequestBody && Object.keys(bomSaveRequestBody)?.length > 0) {
      // Post BOM JSON to parent window for external consumer
      try {
        if (window?.parent) {
          window.parent.postMessage({ type: 'UBUILDER_BOM_READY', payload: bomSaveRequestBody }, '*');
        }
      } catch (e) {
        // swallow postMessage errors silently
      }
      dispatch(SAVE_BOM_FOR_AURORA(productId.toString(), projectId, bomSaveRequestBody, true));
    }
  }

  sendBomToTheOs = () => {
    const{projectConfiguration:{ productId, projectId }, bom: { partsList, extraParameters },railsSelector: { railsList, selectOnlySMHDRails }} = state();
    const bomSaveRequestBody = parseDataForBomSave(partsList, railsList, extraParameters, products[productId], selectOnlySMHDRails);
    if (bomSaveRequestBody && Object.keys(bomSaveRequestBody)?.length > 0) {
      try {
        if (window?.parent) {
          window.parent.postMessage({ type: 'UBUILDER_BOM_READY', payload: bomSaveRequestBody }, '*');
        }
      } catch (e) {}
    }
    dispatch(SAVE_BOM_FOR_OS(productId.toString(), projectId, bomSaveRequestBody, true));
    // saveBomAndDownloadPdf();
  }

  printTable = () => {
    // Build BOM JSON and post to parent before triggering PDF download
    const{projectConfiguration:{ productId }, bom: { partsList, extraParameters },railsSelector: { railsList, selectOnlySMHDRails }} = state();
    const bomSaveRequestBody = parseDataForBomSave(partsList, railsList, extraParameters, products[productId], selectOnlySMHDRails);
    if (bomSaveRequestBody && Object.keys(bomSaveRequestBody)?.length > 0) {
      try {
        if (window?.parent) {
          window.parent.postMessage({ type: 'UBUILDER_BOM_READY', payload: bomSaveRequestBody }, '*');
        }
      } catch (e) {}
    }
    saveBomAndDownloadPdf();
  }

  tableTitle() {
    const{projectConfiguration} = state();
    return (
      <div className="table-title">
        <div className="table-title-info control-panel-label">
          Complete part list
        </div>
        <div className="table-title-legend">
          <div>LEGEND</div>
          <div className="base-part-squere">
            <i role="button" className="material-icons">
              stop
            </i>
          </div>
          <div>Base System Part</div>
          <div className="accessory-part-squere">
            <i role="button" className="material-icons">
              stop
            </i>
          </div>
          <div>Accessory</div>
        </div>
        {projectConfiguration?.is_aurora_project && (
          <div onClick={this.sendBomToTheAurora} className="table-title-print">
            <img src={require("assets/media/icons/send_data_to_aurora.png")} height={40} width={40}/>
            <div>EXPORT TO AURORA</div>
          </div>
        )}
        {projectConfiguration?.is_os_project && (
          <div onClick={this.sendBomToTheOs} className="table-title-print">
            <img src={require("assets/media/icons/send_bom_to_opensolar.png")} height={35} width={35}/>
            <div>EXPORT TO OPENSOLAR</div>
          </div>
        )}
        {!(projectConfiguration?.is_aurora_project || projectConfiguration?.is_os_project) && (
          <div onClick={this.printTable} className="table-title-print">
            <div className="print-table-icon">
              <i tabIndex={0} role="button" className="material-icons">
                print
              </i>
            </div>
            <div>PRINT THIS LIST</div>
          </div>
        )}
        
      </div>
    );
  }

  tableHeader() {
    return (
      <TableHeader className="part-list-table-header">
        <TableRow>
          <TableColumn>
            <div>part number</div>
          </TableColumn>
          <TableColumn>
            <div>part type</div>
          </TableColumn>
          <TableColumn>
            <div className="empty-div">.</div>
            <div>description</div>
          </TableColumn>
          <TableColumn>
            <div className="empty-div">.</div>
            quantity
          </TableColumn>
          <TableColumn>
            <div>suggested</div>
            <div>quantity</div>
          </TableColumn>
          <TableColumn>
            <div>unit</div>
            <div>price (USD)</div>
          </TableColumn>
          <TableColumn>
            <div>total list</div>
            <div>price (USD)</div>
          </TableColumn>
        </TableRow>
      </TableHeader>
    );
  }

  tableBody() {
    const { preview } = this.props;
    
    if (preview) {
      return (
        <TableBody>{this.tableRows()}</TableBody>
      );
    }

    return (
      <TableBody>{this.tableRows().concat(this.tableTotalRow())}</TableBody>
    );
  }

  showPartImage = (partImage, e) => {
    this.imageX = e.clientX + 10
    this.imageY = e.clientY
    this.partImageName = partImage;
    this.showImage = true;
    this.forceUpdate();
  }

  hidePartImage = () => {
    this.showImage = false;
    this.imageX = null;
    this.imageY = null;
    this.partImageName = null;
    this.forceUpdate();
  }

  validatePartQuantity = (partNumber, qty) => {
    const { dispatch } = this.props;
    
    if (qty > 1000000) {
      dispatch(SET_NEW_PART_QUANTITY(partNumber, qty));
    }
    
  }

  partQuantityColumn(part: bomPart) {
    const { preview } = this.props;

    if (preview) {
      return part.quantity || 0;
    }

    return (
      <TextField
        id="part-quantity"
        value={part.quantity}
        onBlur={this.validatePartQuantity.bind(this, part.number, part.quantity)}
        onChange={this.props.onChangeQuantity.bind(this, part.number)}
        type="number"
        onKeyDown = {(e)=>{
          if (e.key === '-' || e.key === '+' || e.key === '.' || e.key === 'e' || e.key === 'E') {
            e.preventDefault()
          }
        }}
        min={0}
      />
    );
  }

  dynamicSort = (property) => {
    let newProperty = property;
    let sortOrder = -1;
    if (property[0] === '-') {
      sortOrder = -1;
      newProperty = newProperty.substr(1);
    }
    return function (a, b) {
      const result =
        a[newProperty] < b[newProperty]
          ? -1
          : a[newProperty] > b[newProperty]
            ? 0
            : 1;
      return result * sortOrder;
    };
  }

  makePartTypeClassFriendly(className) {
    return className
      .split(' ')
      .join('-')
      .split('.')
      .join('-')
      .toLocaleLowerCase();
  }



  tableRows() {
    const{projectConfiguration} = state();
    const uanchorList = projectConfiguration?.projectEnvConfig?.uanchor_part_number || [];
    const isDomesticSelected = projectConfiguration.projectEnvConfig.domestic_content || projectConfiguration.projectEnvConfig.is_domestic_mlpe_required;
    const { partsList, productId, preview } = this.props;
    let newPartList;
    if(partsList && partsList.length>0) {
      newPartList = partsList.filter((elem, index, self) => self.findIndex(
        ele => ele.number === elem.number) === index);
        };
    return sortBomTableByUniracRequest(products[productId], newPartList)
      .map(
      (part: any, index) =>
        !part.disabled && (
          <TableRow key={this.makePartTypeClassFriendly(part.number)} className={`part-row part-row-${this.makePartTypeClassFriendly(part.number)}`}>
            <TableColumn className="part-number-and-image" style={{ position: 'relative'}}>
              <div style={{whiteSpace: 'pre-line'}} className={`part-number ${this.makePartTypeClassFriendly(part.number)}`}>{part.number.replace('6 (U','6 \n  (U')}</div>
              {S5_ATTACHMENT_PARTS.includes(part.number) || !part.image || part.image.includes('default.jpg') || part.number === 'RAYTV3TOOL' ? null : <img
                alt="part_image"
                className="part-image"
                src={`${location.protocol}//${appConfig.apiUrl.slice(0, -1)}${part.image}`}
                onMouseOver = {this.showPartImage.bind(null, part.image)}
                onMouseLeave={this.hidePartImage}
              />
              }
            </TableColumn>
            <TableColumn
              className={
                part.category === 'Base'
                  ? `base-part ${this.makePartTypeClassFriendly(part.type)} ${this.makePartTypeClassFriendly(part.type)}-${this.makePartTypeClassFriendly(part.number)}`
                  : `accessory-part ${this.makePartTypeClassFriendly(part.type)} ${this.makePartTypeClassFriendly(part.type)}-${this.makePartTypeClassFriendly(part.number)}`
              }
            >
              {part.type}
            </TableColumn>
            <TableColumn
              grow={true}
              className="md-cell--middle desc-and-color"
              tooltipLabel={
                part.description.length > 100 ? part.description : null
              }
            >
              <span style={{ display: 'inline-block', paddingTop: '7px' }}>
                {part.description.length > 100
                  ? `${part.description.substring(0, 100).toUpperCase()}...`
                  : part.description.toUpperCase()}
                {(uanchorList && uanchorList.includes(part.number))? <p style={{ margin:'10px 0 5px 0', color: "#cf5232", fontSize: "1Opx", lineHeight: 1 }}>Contact Unirac for Pricing</p> : null}
                {SM_168_PARTS.includes(part.number) ? (<span className='part-number-warning'> - CONFIRM AVAILABILITY<br/> WITH YOUR DISTRIBUTOR, 168" LENGTH IS <br/>IS BEING DISCONTINUED - TRANSITIONING<br/> TO 185" LENGTH</span>) : null}
                {SM_208_PARTS.includes(part.number) ? (<span className='part-number-warning'> - CONFIRM AVAILABILITY<br/> WITH YOUR DISTRIBUTOR, 208" LENGTH IS <br/>IS BEING DISCONTINUED - TRANSITIONING<br/> TO 185" LENGTH</span>) : null}
                {PARTS_BELONG_FOR_PACK_NOTE.some(partItem => partItem.partNumber === part.number) ? (<><span className="part-description-note"><strong> - Minimum Pack Size Quantities of {partToPackMap[part.number]}.</strong></span></>) : null}
                {part.domestic && !isDomesticSelected && ![2, 9, 11, 14, 15, 19, 20, 24, 25, 26, 27, 28, 30, 31, 32, 35, 36, 34, 99].includes(products[productId]) && !(products[productId] === 33 && applyDomesticContent(projectConfiguration.projectVersion)) ? <p style={{ margin:'10px 0 5px 0', color: "#cf5232", fontSize: "1Opx", lineHeight: 1 }}>US-manufactured part available. For guaranteed domestic content, add -US to the end of the part number.</p> : null}
                {S5_ATTACHMENT_PARTS.includes(part.number) ? <p style={{ margin:'10px 0 5px 0', color: "#cf5232", fontSize: "1Opx", lineHeight: 1 }}>Not supplied through Unirac, please contact your supplier for S-5! components.</p> : null}
                {([2, 9, 11, 14, 15, 19, 20, 24, 28, 30, 31, 32, 35, 33, 34, 36, 25, 26, 27, 99].includes(products[productId])  && isDomesticPart(part.number) && isDomesticSelected) ? <p style={{ margin:'10px 0 5px 0', color: "#cf5232", fontSize: "1Opx", lineHeight: 1 }}>Domestic Content.</p> : null}
              </span>
              {part.variants &&
                !preview &&
                part.variants.length > 0 &&
                products[productId] !== 12 && (
                  <ColorsVariantsSelector
                    partToReplace={part}
                    variants={part.variants}
                  />
                )}
            </TableColumn>
            <TableColumn>{this.partQuantityColumn(part)}</TableColumn>
            <TableColumn className="part-suggested-quantity">{part.suggested_quantity}</TableColumn>

            <TableColumn className="part-price">{(uanchorList && uanchorList.includes(part.number)) ? '0.00' : Number(part.price).toFixed(2)}</TableColumn>
            <TableColumn className="part-total-price">{(uanchorList && uanchorList.includes(part.number)) ? '0.00' : Number(part.price * part.quantity).toFixed(2)}</TableColumn>
          </TableRow>
        ),
    );
  }

  tableTotalRow() {
    const { partsList } = this.props;
    let newPartList;
    if(partsList && partsList.length>0) {
      newPartList = partsList.filter((elem, index, self) => self.findIndex(
        ele => ele.number === elem.number) === index);
        };
    const { baseSystemPrice, accessoriesPrice } = calculatePrices(newPartList);
    return (
      <TableRow key="total_row" className="part-row">
        <TableColumn style={{ position: 'relative' }} />
        <TableColumn style={{ position: 'relative' }} />
        <TableColumn style={{ position: 'relative' }}>
          <TotalListPrice totalPrice={baseSystemPrice + accessoriesPrice} />
        </TableColumn>
      </TableRow>
    );
  }

  partImage() {
    let imageDiv;
    if (this.showImage && this.partImageName && !this.partImageName.includes('default.jpg')) {
      imageDiv = (
        <div
          className="preview-image-box"
          style={{ position: 'fixed', top: this.imageY, left: this.imageX }}
        >
          <img
            alt="part_image"
            src={`${location.protocol}//${appConfig.apiUrl.slice(0, -1)}${this.partImageName}`}
          />
        </div>
      );
    } else {
      imageDiv = null;
    }

    return imageDiv;
  }

  render() {
    return (
      <div className="bom_table">
        {this.tableTitle()}
        <DataTable className="bom_table_data" plain={true}>
          {this.tableHeader()}
          {this.props.partsList?.length ? this.tableBody(): null}
        </DataTable>
        {this.partImage()}
      </div>
    );
  }
}
